import type { FaireProductEntity } from "../../entity_types/product";

export const p_fpgvatpfct: FaireProductEntity = {
  token: "p_fpgvatpfct",
  type: "product",
  name: "French Thank You Greeting Card",
  brandToken: "b_6pxaaxfg",
  brandName: "La Familia Green",
  imageUrl:
    "https://cdn.faire.com/fastly/af5d7023bd04503ee5516bd8d398c04063fd707fa8de9f6e3af9610ecaf3fcc2.jpeg",
  galleryImageUrls: [],
  priceDollars: 3,
  description:
    'Flat printed on FSC certified paper from an original handcut collage, drawing, or print.\n\n4.25" x 5.5" folded card with recycled kraft envelope\n\nBlank inside\n\nMade in USA',
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:54:23.282Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
